__webpack_require__.p = "https://static.lootbar.gg/website/";